<div class="icon-container">
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 8V4H8V8H4V10H8V14H10V10H14V8H10Z" [attr.fill]="color"/>
  </svg>
</div>
